module.exports = __webpack_public_path__ + "assets/img/template_padrao.ff5163fd.svg";